@if (isLoggedIn) {
    <!-- <app-authorized-layout [menuItems]="menuItems" [isLoggedIn]="isLoggedIn" [isMenuCollapsed]="isMenuCollapsed"></app-authorized-layout> -->
    <div>After authentication data</div>
}
@else {
<app-unauthorized-layout class="h-full md:min-h-screen">
    <router-outlet></router-outlet>
</app-unauthorized-layout>
}